<div class="container-card" style="cursor: pointer;">
    <div class="container-img">
        <img class="img-card-event" [src]="eventImgURL" />
    </div>
    <div class="info-card d-grid">
        <!-- <div class="d-flex w-100 align-items-center">
        <span class="justify-self-end price-event">Desde <span class="price-free">{{event.preciodesde}}€</span></span>
    </div> -->
        <p style="margin: 0;" class="text-info-event pointer-in">{{event.title}}</p>
        <div class="align-self-end date-event pointer-in">
            <fa-icon class="icon-cart-line-trash" [icon]="faCalendar"></fa-icon>
            <span>{{ (event.start_date | date: 'dd MMM':'+0000') }}</span>
            <span *ngIf="event.start_date != event.end_date;else divHour">- {{ (event.end_date | date: 'dd MMM':'+0000')
                }}</span>
            <ng-template #divHour>
                <span>| {{event.start_date | date:'HH:mm':'+0000'}}</span> </ng-template>
        </div>
    </div>